import { Factory } from 'miragejs'
import { STATUS_ACTIVE } from 'district-ui-client/services/school-rollover'

export default Factory.extend({
  status: STATUS_ACTIVE,
})
